export default {
  PRODUCTION: 'production',
  LOCAL: 'local',
  DEV: 'dev'
}
